import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-flag",
  "use": "icon-flag-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-flag\"><path fill=\"#ffffff\" d=\"M844.544 149.333333l-200 202.666667 200 202.666667H256v341.333333H192V149.333333h652.544z m-153.088 64H266.666667v277.333334h424.789333l-136.832-138.666667 136.832-138.666667z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol